require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/dimmer.css');
require('./section4.styl');

import React from 'react';

class Section4 extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (

            <div className='section four wrapper'>

                <div className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment padded`}>
                    <div className='ui inverted simple dimmer'></div>
                        {/*<h3>Neun Operationen, neun Vollnarkosen</h3>*/}

                  <p className='section-text'>
                    Olivers finanzieller Abstieg beginnt 2009 mit einer Netzhautablösung im linken Auge. Es folgen <strong>neun Operationen, neun Vollnarkosen,</strong> neunmal zwei bis drei Wochen Bettruhe. Die Symptome der Narkolepsie, mit der er sich arrangiert hatte, verschlimmerten sich. Es reichte nicht mehr aus, dass er sich täglich vier- bis fünfmal für 20 Minuten hinlegt. Er muss nun jeweils 60 bis 90 Minuten schlafen. Sein Geschäft leidet. Er kann nicht termingerecht liefern. Selbst Stammkunden springen ab.                            </p>

                            <p className='section-text'>
                              2012 trennen sich er und seine Partnerin. «Das Leben mit einem Narkoleptiker ist anstrengend», sagt Oliver dazu. Jetzt bezahlt er die Miete alleine. Er bekommt eine Teil-IV-Rente. 40 Prozent müsste er zusätzlich noch arbeiten. Doch seine Krankheit vereinnahmt ihn mittlerweile zu stark. <strong>Das Geschäft ist komplett eingebrochen.</strong> Seine Mutter unterstützt ihn ungefragt mit ein paar 100 Franken pro Monat. Doch sie bekommt Alzheimer, braucht Pflege. Mit seinem Vater hatte er sich schon lange überworfen.                            </p>

                  <p className='section-text'>
                    Rund 1800 Franken IV- und 156 Franken Pensionskassen-Rente stehen zirka 1630 Franken Fixkosten gegenüber: Miete, Strom, Wasser, Haftpflicht, Krankenkasse plus Franchise und Selbstbehalt, die Oliver wegen Arztbesuchen und Medikamenten jedes Jahr voll beanspruchen muss. <strong>326 Franken bleiben ihm pro Monat zum Leben.</strong> Rechnungen bleiben unbezahlt. Oliver beantragt eine volle IV-Rente. Es heisst, sie komme bald. Er wartet. Fünfmal wird er betrieben – vom Staat und der Krankenkasse. Dann, im September 2015, wird Oliver zum Sozialhilfeempfänger. Die volle IV-Rente, die ihn wieder von der Sozialhilfe befreit, wird ihm schliesslich erst viel später zugesprochen.                            </p>

                  <p className='section-text'>
                    Die Armut sieht man Oliver und seiner Wohnung nicht an. Büro, Schlafzimmer, Wohnzimmer, Küche – alles wirkt etwas unordentlich, aber es fehlt nichts. Einen Fernseher hat er nicht, dafür einen grossen Drucker: «Ein Geschenk!», rechtfertigt er sich gleich. Wie so vieles hier in der Wohnung.                            </p>

                  <p className='section-text'>
                    <strong>Armut stellt man sich anders vor:</strong> Elend, Obdachlosigkeit, Hunger. Deshalb betrete man ein «Minenfeld», wenn man sich mit Armut in der Schweiz beschäftige, wie der <a href='http://www.beobachter.ch/justiz-behoerde/buerger-verwaltung/artikel/armut-in-der-schweiz_wenns-wieder-nur-brot-gibt/' target='_blank'>«Beobachter»</a> schreibt. Sozialhilfeempfänger gelten oftmals als verwöhnte, faule Schmarotzer. In der Schweiz könne jeder arbeiten, wenn er nur wolle. Wer sich einen Fernseher oder ein Handy leisten kann, ist nicht arm. Andrea Gärtner sieht das anders. Die Sozialarbeiterin arbeitet in der mobilen Sozialberatung der Caritas Zürich. Sie berät täglich Familien im Stadtkreis 12, dem Kreis mit der höchsten Sozialhilfequote. Was Gärtner über gängige Vorurteile sagt, sehen Sie im Video:                            </p>
                </div>

            </div>
        );
    }
}

Section4.defaultProps = {};

Section4.propTypes = {
    readerIsCityCitizen: React.PropTypes.bool,
    readerMadeHisChoice: React.PropTypes.bool
};

export default Section4;



// WEBPACK FOOTER //
// ./src/components/section4/section4.js